import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button} from '@material-ui/core';
import Radio from '@mui/material/Radio';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import axios from 'axios';
import {API_URL} from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {
  const [open, setOpen] = React.useState(false); 
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const [accountChk, setAccountChk] = React.useState(1);
  const [leadChk, setLeadChk] = React.useState(1);
  const [activityChk, setActivityChk] = React.useState(1);
  
  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}

  React.useEffect(() => {	
    if(props.row && props.row.activities>1 && open){	
      setAccountChk(props.row.accounts);
      setLeadChk(props.row.leads);
      setActivityChk(props.row.activities);

    }else{
      setAccountChk(1);
      setLeadChk(1);
      setActivityChk(1);

    }
	}, [props.rows,open]);

  const handleAccount = (event) => {
    setAccountChk(event.target.value);
  };
  const handleLead = (event) => {
    setLeadChk(event.target.value);
  };
  const handleActivity = (event) => {
    setActivityChk(event.target.value);
  };

  
	function saveData(){
    
		if(props.row && props.row.tenders>0){ 
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/form-data',
					'device': 'web',
					'registerId': props.userObj.registerId,
					'uid': props.userObj.loginId,
					'fullName': props.userObj.fullName,
					'token': props.userObj.token,
				}
			}; 


          const data = new FormData();
          data.append('moduleName', 'lead');
          data.append('accountFlag', accountChk);
          data.append('leadFlag', leadChk);
          data.append('activityFlag', activityChk);

          axios.post(API_URL+'/crm-save-modules-visibility', data, axiosHeader)
          .then((response) => {
            ///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
            if(response.status===200 && response.data.responseTxt==="success"){
              ///alert(JSON.stringify(response.data));
              props.updatedList(response.data.obj);	
              setSeverityAlert("success");              
              setShowAlert(true);
              setAlertMessage("Visibility setting has been saved."); 
              setOpen(false);
              return false;

            }else if(response.data.responseTxt==="invalidtoken"){
                window.location.href='invalidtoken';
      
            }else{
              setSeverityAlert("error");
              setShowAlert(true);
              setAlertMessage("Visibility setting could not be saved.");			
              return false;
            }
          })
          .catch((error) => {
              setSeverityAlert("error");
              setShowAlert(true);
              setAlertMessage(""+error);			
              return false;
          })	

		}		
	}
  

  return (
    <>
      <Dialog fullWidth maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-10px'}} onClose={handleClose}>Update Visibility Setting</DialogTitle>
          <DialogContent style={{height:'88vh'}}>
            <Grid item   md={12} xs={12} className="test-instructions" >              
                  <p>
                    <TableContainer component={Paper}>
                      <Table sx={{ width: '100%' }} aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell><b>Module</b></TableCell>            
                            <TableCell align="center" ><b>Public</b></TableCell> 
                            <TableCell align="center" ><b>Private</b></TableCell>      
                          </TableRow>
                        </TableHead>
                        <TableBody>

                          <TableRow
                              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                              <TableCell component="th" scope="row">Accounts</TableCell>              
                                <TableCell align="center" >
                                  <Radio
                                    checked={accountChk == 1}
                                    onChange={handleAccount}
                                    value={1}
                                    name="account-buttons"
                                    inputProps={{ 'aria-label': 'A' }}
                                    style={{height: '2em',width:'2em', accentColor: '#888888'}}
                                  />
                                </TableCell>
                                <TableCell align="center" >
                                  <Radio
                                    checked={accountChk == 2}
                                    onChange={handleAccount}
                                    value={2}
                                    name="account-buttons"
                                    inputProps={{ 'aria-label': 'B' }}
                                    style={{height: '2em',width:'2em', accentColor: '#888888'}}
                                  />
                                </TableCell>
                            </TableRow>
                            <TableRow
                              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                              <TableCell component="th" scope="row">Leads</TableCell>              
                                <TableCell align="center" >
                                  <Radio
                                    checked={leadChk == 1}
                                    onChange={handleLead}
                                    value={1}
                                    name="lead-buttons"
                                    inputProps={{ 'aria-label': 'A' }}
                                    style={{height: '2em',width:'2em', accentColor: '#888888'}}
                                  />
                                </TableCell>
                                <TableCell align="center" >
                                  <Radio
                                    checked={leadChk == 2}
                                    onChange={handleLead}
                                    value={2}
                                    name="lead-buttons"
                                    inputProps={{ 'aria-label': 'B' }}
                                    style={{height: '2em',width:'2em', accentColor: '#888888'}}
                                  />
                                </TableCell>
                            </TableRow>
                            <TableRow
                              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                              <TableCell component="th" scope="row">Activities</TableCell>              
                                <TableCell align="center" >
                                  <Radio
                                    checked={activityChk == 1}
                                    onChange={handleActivity}
                                    value={1}
                                    name="activity-buttons"
                                    inputProps={{ 'aria-label': 'A' }}
                                    style={{height: '2em',width:'2em', accentColor: '#888888'}}
                                  />
                                </TableCell>
                                <TableCell align="center" >
                                  <Radio
                                    checked={activityChk == 2}
                                    onChange={handleActivity}
                                    value={2}
                                    name="activity-buttons"
                                    inputProps={{ 'aria-label': 'B' }}
                                    style={{height: '2em',width:'2em', accentColor: '#888888'}}
                                  />
                                </TableCell>
                            </TableRow>
                          
                        </TableBody>
                      </Table>
                  </TableContainer>


                      <Box mt={2}>
                          <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Cancel</Button>
					    	          <Button onClick={() => {saveData()}} size="small" variant="contained" style={{marginRight:12, backgroundColor:'#008000',color:'#FFF',marginRight:10}} >Save</Button>
								      </Box>

                  </p>              
            </Grid>
          </DialogContent>
      </Dialog>
      
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

    </>
  );

});

export default CustomizedDialogs;